export default __webpack_public_path__ + "static/media/vaccin.aae13417.png";